import { TelegramProductShortResponseDto } from '@/generated';
import { getProductPlacementLabel } from '@/utils/getProductPlacementLabel';
import { useLocale, useTranslations } from 'next-intl';

type ProductPlacementProps = {
  product: TelegramProductShortResponseDto;
};

export function ProductPlacement({ product }: ProductPlacementProps) {
  const t = useTranslations('product');
  const locale = useLocale();
  const label = getProductPlacementLabel(product, locale);

  return label ?? t('placementNotFound');
}
